export default () => ({
  suppliedFormData: null,
  countries: null,
  exchangeIdentifier: null,
  deviceVerificationResponse: null,
  locale: (window.AppData || {}).locale || '',
});
